import { FC } from 'react';
import { Box, VStack } from '@chakra-ui/react';

import useFeatureFlagsSwitcher from 'common/hooks/useFeatureFlagsSwitcher';
import Text from 'components/_core/Text';

import type { DetailedTransaction } from '../../hooks/useDetailedTransactionQuery';
import Attachments from './components/Attachments';
import LinkInvoiceOrUpload from './components/LinkInvoiceOrUpload';
import locales from './locales';

const MAX_ATTACHMENTS = 5;

interface ReceiptsProps {
  transaction: DetailedTransaction;
}

const Receipts: FC<ReceiptsProps> = ({ transaction }) => {
  const { featureFlags } = useFeatureFlagsSwitcher();
  const { invoiceId, receipt, receipts, transactionId, type, value } =
    transaction;

  const totalAttachments = (receipts?.length ?? 0) + Number(Boolean(invoiceId));
  const shouldShowAttachments = Boolean(totalAttachments) || Boolean(receipt);
  /**
   * @todo Remove feature flag after multi-doc release
   * @link https://linear.app/shine/issue/CAC-58
   */
  const shouldShowUpload = featureFlags.enableMultipleTransactionDocs
    ? totalAttachments < MAX_ATTACHMENTS
    : !receipt && !invoiceId;

  return (
    <Box paddingX="space-16" paddingY="space-24">
      <Text paddingBottom="space-16">{locales.title}</Text>

      <VStack align="unset" spacing="space-32">
        {shouldShowUpload ? (
          <LinkInvoiceOrUpload transaction={transaction} />
        ) : null}

        {shouldShowAttachments ? (
          <Attachments
            invoiceId={invoiceId}
            receipts={receipts ?? []}
            singleReceipt={receipt}
            transactionId={transactionId}
            transactionTotal={value}
            transactionType={type}
          />
        ) : null}
      </VStack>
    </Box>
  );
};

export default Receipts;
